import type {VariantResponseBody} from '@dms/api/new-vehicle';

import {createdItem} from './createdItem';
import {removedItem} from './removedItem';
import {variantChangeName} from './variantChangeName';

/**
 * The one row an enable switch of a Variant of an online trim adds to the pricelist (enable: — → price) or takes
 * from it (disable: price → —). On enable, pass the price the write sends, as the server lists it.
 */
export const variantEnabledChange = (change: {
  variant: Pick<VariantResponseBody, 'id' | 'orderCode' | 'priceNet'>;
  trimName: string;
  engineName: string;
  enabled: boolean;
}) =>
  (change.enabled ? createdItem : removedItem)(
    'variant',
    change.variant.id,
    variantChangeName(change.trimName, change.engineName, change.variant.orderCode),
    change.variant.priceNet
  );
